/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const es_accounts_subtitle = /** @type {(inputs: {}) => string} */ () => {
	return `Recibe fondos en los países o criptomonedas más importantes con Bloque.`
};

const en_accounts_subtitle = /** @type {(inputs: {}) => string} */ () => {
	return `Receive funds in major countries or cryptocurrencies with Bloque.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const accounts_subtitle = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.accounts_subtitle(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("accounts_subtitle", locale)
	if (locale === "es") return es_accounts_subtitle(inputs)
	return en_accounts_subtitle(inputs)
};
export { accounts_subtitle as "accounts.subtitle" }